<template>
  <div>
    <TopBar title="Détails"/>
    <div class="page-content">
      <div class="container">
        <div v-if="loading" class="dz-spinner color-spinner">
          <div class="spinner-border spinner-sm me-2 mb-2 text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else class="">
          <div class="">
            <div class="image-menu">
              <img v-if="menu.image_url" style="border-radius: 10px;" :src="menu.image_url" alt="food">
              <img v-else-if="isBarMenu" style="border-radius: 10px;" src="../../../assets/menu_bar.png">
              <img v-else style="border-radius: 10px;" src="../../../assets/menu_kitchen.png">
            </div>
          </div>
          <div class="company-detail mt-3">
            <div class=" detail-content">
              <div class="flex-1">
                <div class="d-flex justify-content-between">
                  <div class="title">
                    <h5 class="text-start text-black">{{ menu.name }}</h5>
                  </div>
                  <ul class="item-inner d-block">
                    <li>
                      <div class="reviews-info">
                        <i class="fa-solid fa-clock" style="color: #D8DDE6;"></i>
                        <h6 class="mb-0 ms-2">{{ menu.duration }} Min</h6>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-center">
                    <h5 class="price">{{ price }} f</h5>
                  </div>
                  <div v-if="menu.default">
                    <Stepper id="menu-quantity" v-model="menuForm.meals[0].quantity"/>
                  </div>
                  <div v-else>
                    <Stepper id="menu-quantity" v-model="menuForm.quantity"/>
                  </div>
                </div>
              </div>
              <p class="text-justify mt-1 mb-0">{{menu.description}}</p>
            </div>
          </div>
          <br>
          <div class="accordion style-2" id="accordionExample">
            <div v-if="menu.sale_element_with_attributes?.length>0 && !menu.default" class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed text-uppercase" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  {{ getVariationName() }} ({{ menuForm.meals?.length }})
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div class="variation">
                    <div v-if="menuForm.quantity > 0 && selectedVariationTotal < menuForm.quantity" class="less">
                      <div class="alert alert-info light alert-dismissible fade show">
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="me-2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                        Vous pouvez en sélectionner {{menuForm.quantity}}.
                      </div>
                    </div>
                    <div v-if="menuForm.quantity > 0 && selectedVariationTotal == menuForm.quantity" class="equal">
                      <div class="alert alert-success light alert-dismissible fade show">
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="me-2"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                        Vous avez atteint le quorum de {{menuForm.quantity}}.
                      </div>
                    </div>
                    <div v-if="menuForm.quantity > 0 && selectedVariationTotal  > menuForm.quantity" class="more">
                      <div class="alert alert-danger light alert-dismissible fade show">
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="me-2"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                        Vous avez dépassé le quorum de {{menuForm.quantity}}.
                      </div>
                    </div>

                    <Supplement id="variation" v-model="menuForm.meals" :extras="menu.sale_element_with_attributes"
                                :orderExtras="menuForm.meals"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="menu.accompaniments?.length > 0" class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  {{ $t('details.accompagnment') }} ({{menuForm.quantity}})
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div class="accordion-body pt-0">
                  <div class="accompagnement">
                    <div v-if="menuForm.quantity > 0 && selectedAccompagnmentTotal < menuForm.quantity" class="less">
                      <div class="alert alert-info light alert-dismissible fade show">
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="me-2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                         Vous pouvez en sélectionner {{menuForm.quantity}}.
                      </div>
                    </div>
                    <div v-if="menuForm.quantity > 0 && selectedAccompagnmentTotal == menuForm.quantity" class="equal">
                      <div class="alert alert-success light alert-dismissible fade show">
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="me-2"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                        Vous avez atteint le quorum de {{menuForm.quantity}}.
                      </div>
                    </div>
                    <div v-if="menuForm.quantity > 0 && selectedAccompagnmentTotal  > menuForm.quantity" class="more">
                      <div class="alert alert-danger light alert-dismissible fade show">
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="me-2"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                         Vous avez dépassé le quorum de {{menuForm.quantity}}.
                      </div>
                    </div>
                    <Supplement id="accompaniement" :showPrice="false"  :extras="menu.accompaniments" v-model="menuForm.accompaniements"/>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="menu.accompaniments?.length > 0" class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  {{ $t('details.extra') }} ({{extraPrice}})
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div class="accordion-body pt-0">
                  <Supplement id="supplement" :extras="menu.accompaniments" v-model="menuForm.supplements"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br><br><br><br>
    <div class="footer fixed">
      <div class="footer-wrapper container">
        <a @click.prevent="validateBeforeSubmit" class="btn btn-sm btn-primary text-start w-100 btn-rounded" >
         <span class="me-2" style="font-weight: lighter"> {{ $t('commander') }}</span> ({{extraPrice + price}}f)
        </a>
      </div>
    </div>

    <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom1">
      <div class="container">
        <div class="offcanvas-header">
          <h6 class="offcanvas-title" id="offcanvasBottomLabel">{{ $t('comment') }}</h6>
          <button class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"><i class="fa fa-close"></i></button>
        </div>
        <div class="offcanvas-body small">
          <div class="input-group mb-3 input-radius">
            <textarea v-model="menuForm.comment" class="form-control" placeholder="Renseigner un commentaire à l'endroit de la cuisine" rows="4"></textarea>
          </div>
          <div class="text-center m-t20 d-flex">
            <button @click="submitAndGoToMenu" class="btn btn-sm btn-light me-2 w-100">{{ $t('skip') }}</button>
            <button @click="submitAndGoToCart" class="btn btn-sm btn-primary w-100">{{ $t('cart') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="errorModal"  aria-labelledby="errorModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center small p-4">
            <i class="fa fa-4x fa-times-circle text-danger m-b15"></i>
            <h5>Oups...</h5>
            <p class="m-b0">Vous avez mal saisie votre commande. Veuillez vérifier merci!</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import Stepper from "@/components/stepper";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import Supplement from "@/components/supplement";
import {useFormatVariation} from "@/composables/useFormatVariation";

const store = useStore()
const route = useRoute()
const router = useRouter()

const {$getVariationName} = useFormatVariation()

const loading = ref(false)
const bsOffcanvas = ref('')
const menu = ref({})
const menuForm = reactive({
    menu_id: '',
    menu_name: '',
    menu_image: '',
    quantity: 1,
    comment: '',
    supplements: [],
    meals: [{quantity: 1}],
    accompaniements: [],
})

onMounted(() => {
  getMeal()
})

watch(() => menuForm.meals[0].quantity, () => {
  if(menu.value.default){
    menuForm.quantity = menuForm.meals[0].quantity
  }
})

watch(() => menu.value, () => {
  menuForm.menu_name = menu.value.name
  menuForm.menu_image = menu.value.image_url
  if(menu.value.default){
    menuForm.meals = [{
      selected: true,
      id: menu.value.sale_element_with_attributes[0].id,
      quantity: 1,
      price: menu.value.price,
      name:menu.value.name
    }]
  }else{
    menuForm.meals = [{
      selected: true,
      id: menu.value.sale_element_with_attributes[0]?.id,
      quantity: 1,
      price: menu.value.sale_element_with_attributes[0]?.price,
      name: $getVariationName(menu.value.sale_element_with_attributes[0]?.attributeAndCombination)
    }]
  }
})

const price = computed(() => menuForm.meals.reduce((a,b) => a + parseFloat(b.price) * parseFloat(b.quantity),0))
const extraPrice = computed(() => menuForm.supplements.reduce((a,b) => a + parseFloat(b.price) * parseFloat(b.quantity),0))
const selectedVariationTotal = computed(() => menuForm.meals?.reduce((a,b) => a + b.quantity, 0 ))
const selectedAccompagnmentTotal = computed(() => menuForm.accompaniements?.reduce((a,b) => a + b.quantity, 0 ))
const isBarMenu = computed(() => {
  return menu.cooking_place == 'BAR'
})

function getMeal(){
  loading.value = true
  store.dispatch('menu/loadMeal', route.params._id).then(response => {
    //TODO cas sans variation ajouter les valeurs par défaut de meal
    menu.value = response.data.product
  }).finally(() => {
    loading.value = false
  })
}

function validateBeforeSubmit(){
  if(selectedAccompagnmentTotal.value > menuForm.quantity || selectedVariationTotal.value > menuForm.quantity || price.value == 0){
    // eslint-disable-next-line no-undef
    $('#errorModal').modal('show')
  }else {
    // eslint-disable-next-line no-undef
    let myOffcanvas = $('#offcanvasBottom1')
    // eslint-disable-next-line no-undef
    bsOffcanvas.value = new bootstrap.Offcanvas(myOffcanvas)
    bsOffcanvas.value.toggle()
  }
}

function submitAndGoToMenu(){
  store.dispatch('cart/addOrderToCart', {...menuForm, total: price.value + extraPrice.value, menu_id: route.params._id})
  bsOffcanvas.value.toggle()
  router.push({name: 'home-page'})
}

function submitAndGoToCart(){
  store.dispatch('cart/addOrderToCart', {...menuForm, total: price.value + extraPrice.value, menu_id: route.params._id})
  bsOffcanvas.value.toggle()
  router.push({name: 'cart-page'})
}

function getVariationName(){
  if(menu.value){
    let firstAttribute = menu.value.sale_element_with_attributes[0].attributeAndCombination
    let name = []
    firstAttribute.map(element => {
      name.push(element.name_with_attribute.split('|')[0])
    })

    return name.join(' / ')
  }
}
</script>

<style scoped>
.item-media img{
  height: 105px;
  min-width: 105px;
  object-fit: cover;
}
.footer.fixed {
  bottom: 59px;
}
.footer-wrapper{
  background-color: rgba(45,163,51, 0.05);
}
.image-menu img{
  width: 100%;
  height: 150px;
  object-fit: cover;
}

btn{
  border-radius: 10px;
}

.accordion.style-2 .accordion-item{
  box-shadow: 0 0 0 0 transparent;
}

.radio .checkmark{
  border: 1px solid var(--secondary);
}
.radio .radio-label input:checked ~ .checkmark{
  background-color: var(--secondary);
  border: 1px solid var(--secondary);
}
.price{
  color: var(--secondary);
  text-align: center;
}
.radio.square-radio .radio-label .checkmark{
  border-radius: 5px;
}
.radio.square-radio .radio-label .checkmark:after{
  border-radius: 5px;
}

.company-detail .item-inner li .reviews-info i{
  color: var(--secondary);
}

.radio .radio-label .checkmark:after{
  background: var(--secondary);
}


.input-radius textarea.form-control{
  border-radius: 10px;
}

.accordion-full .accordion-header{
  border: 0px;
  padding: 0px;
}
.accordion-header{
  padding: 0px;
}
.title .text-black{
}

.radio{
  padding-top: 15px;
  text-align: initial;
}

.accordion-button::after {
  width: 1rem;
  height: 1rem;
  background-size: 1rem;
}


</style>